import { render, staticRenderFns } from "./ProcessRecordList.vue?vue&type=template&id=8626f13e&"
import script from "./ProcessRecordList.vue?vue&type=script&lang=js&"
export * from "./ProcessRecordList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports